import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Accordion, CheckboxFilledIcon, CheckboxIcon, Layout } from '@utilities';

import { getDisplayCurrency } from '../../utilities/helpers';

import styles from './_index.module.scss';

const AddOns = ({ addOns, onAddonChange, paymentOption }) => {
  const handleToggle = (name, selected) => {
    onAddonChange(name, { selected });
  };

  return (
    <Accordion className={styles['addons']} isDefaultOpen label="Optional Add-ons">
      <Layout.Flex.Column as="ul" className={styles['addon-list']} gap="small">
        {addOns.map(({ description, name, selected = false, title, ...addOn }) => {
          const value = addOn[paymentOption.currency] ?? 0;

          return (
            <Layout.Flex
              aria-checked={selected}
              as="li"
              className={classNames(styles['addon-item'], { [styles['is-selected']]: selected })}
              gap="small"
              key={name}
              onClick={() => handleToggle(name, !selected)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleToggle(name, !selected);
                }
              }}
              role="checkbox"
              tabIndex="0"
            >
              <div className={styles['addon-checkbox']}>
                {selected ? <CheckboxFilledIcon /> : <CheckboxIcon />}
              </div>
              <Layout.Fill>
                <Layout.Flex.Column className={styles['addon-detail']} gap="small">
                  <Layout.Flex>
                    <Layout.Fill>
                      <strong className={styles['addon-name']}>{title}</strong>
                    </Layout.Fill>
                    <span>
                      {value} {getDisplayCurrency({ paymentOption, value })}
                    </span>
                  </Layout.Flex>
                  {description && <div>{description}</div>}
                </Layout.Flex.Column>
              </Layout.Fill>
            </Layout.Flex>
          );
        })}
      </Layout.Flex.Column>
    </Accordion>
  );
};

AddOns.propTypes = {
  addOns: PropTypes.arrayOf(PropTypes.object).isRequired, // see Cart component for shape
  onAddonChange: PropTypes.func.isRequired,
  paymentOption: PropTypes.object.isRequired,
};

export default AddOns;
